import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'any',
})
export class StorageService {
  _isBrowser: boolean;

  constructor(@Inject(PLATFORM_ID) private platformId: object) {
    this._isBrowser = isPlatformBrowser(platformId);
  }

  get = (key: string): string => {
    if (this._isBrowser) {
      return localStorage.getItem(key);
    }
  };

  set = (key: string, value: string) => {
    if (this._isBrowser) {
      localStorage.setItem(key, value);
    }
  };

  getSession = (key: string): string | null => {
    if (this._isBrowser) {
      return sessionStorage.getItem(key);
    }
    return null;
  };

  setSession = (key: string, value: string) => {
    if (this._isBrowser) {
      sessionStorage.setItem(key, value);
    }
  };
}
